export const platenComponents = [
  {
    name: "基础设施",
    componentsName: "Infrastructure",
    position: {
      width: 420,
      height: 250,
      top: 20,
      left: 20,
      innerWidth: 1920,
      innerHeight: 969
    },
  },
  {
    name: '电子地图',
    componentsName: "Map",
    position: {
      width: 420,
      height: 200,
      top: 290,
      left: 20,
      innerWidth: 1920,
      innerHeight: 969
    },
  },
  {
    name: '空间情况',
    componentsName: "RoomSituation",
    position: {
      width: 1050,
      height: 470,
      top: 20,
      left: 460,
      innerWidth: 1920,
      innerHeight: 969
    },
  }, {
    name: "环境设备",
    componentsName: "RoomEnvironmentDevice",
    position: {
      width: 580,
      height: 400,
      top: 510,
      left: 520,
      innerWidth: 1920,
      innerHeight: 969
    },
  }, {
    name: "动力设备",
    componentsName: "PowerDevice",
    position: {
      width: 480,
      height: 400,
      top: 510,
      left: 20,
      innerWidth: 1920,
      innerHeight: 969
    },
  }, {
    name: "安防,消防设备",
    componentsName: "SecurityDevice",
    position: {
      width: 388,
      height: 400,
      top: 510,
      left: 1120,
      innerWidth: 1920,
      innerHeight: 969
    },
  }, {
    name: "告警分布",
    componentsName: "AlarmDistribution",
    position: {
      width: 370,
      height: 195,
      top: 20,
      left: 1530,
      innerWidth: 1920,
      innerHeight: 969
    },
  }, {
    name: "告警趋势",
    componentsName: "AlarmTrend",
    position: {
      width: 370,
      height: 220,
      top: 230,
      left: 1530,
      innerWidth: 1920,
      innerHeight: 969
    },
  }, {
    name: "告警信息",
    componentsName: "AlarmInfo",
    position: {
      width: 370,
      height: 445,
      top: 465,
      left: 1530,
      innerWidth: 1920,
      innerHeight: 969
    },
  }
];
